var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorsFlatList.length)?_c('div',{staticClass:"alert alert-danger"},[_c('ul',{staticClass:"mb-0"},_vm._l((_vm.errorsFlatList),function(error,index){return _c('li',{key:index},[_vm._v("\n      "+_vm._s(error)+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }